import React, { useEffect } from 'react'

import { Button,  } from 'reactstrap';
import Select from 'react-select';
import getCountries from "@/service/getCountries";
import getRewardPlatform from "@/service/getRewardPlatform";
import {labelizeNamedData} from '@/shared/helpers'

const MerchantFilter = ({onClickFilterCallback, setUseFilter}) => {
    const [keyword, setKeyword] = React.useState('')
    const [countries, setCountries] = React.useState([])
    const [selectedCountry, setSelectedCountry] = React.useState(null);
    const [vendors, setVendors] = React.useState([])
    const [selectedVendor, setSelectedVendor] = React.useState(0)
    
    useEffect(() => {
        if (countries.length === 0) {
            getCountries()
                .then(result => {
                    setCountries([{label: 'All Countries', value: ''},...labelizeNamedData(result)])
                })
        }
    },[])
    useEffect(() => {
        if (vendors.length === 0) {
          getRewardPlatform()
            .then(result => {
                setVendors([{label: 'All Vendors', value: ''}, ...labelizeNamedData(result), { value: 'physical', label: 'Physical' },])
            })
        }
      },[])

    const onKeywordChange = (e) => {
        setKeyword( e.target.value)
    }

    const onCountryChange = (value) => {
        setSelectedCountry(value);
        onClickFilterCallback( {keyword: keyword, country: value?.value ?? '', vendor: selectedVendor?.value ?? ''})
    }

    const onVendorChange = (value) => {
        setSelectedVendor(value);
        onClickFilterCallback( {keyword: keyword, country: selectedCountry?.value ?? '', vendor: value?.value ?? ''})
    }
    
    const onClickFilter = (event, reset= false) => {
        event.preventDefault();
        if(reset){     
            setKeyword('')   
            setSelectedCountry(null)
            setSelectedVendor(0)
            onClickFilterCallback( {keyword: '', country: '', vendor: ''})
            setUseFilter(true)
        }else{
            onClickFilterCallback( {keyword: keyword, country: selectedCountry?.value ?? '', vendor: selectedVendor?.value ?? ''})
            setUseFilter(true)
        }
    }

    return (
        <form className="form__form-group" onSubmit={onClickFilter}>
            <div className="col-md-4">
                <div className="">
                    <input 
                        value={keyword}
                        onChange={onKeywordChange}
                        type="text"
                        placeholder="Search by ID or name"
                    />
                </div>
            </div>
            <div className="col-md-3 px-0 pr-3" >
                <Select
                    value={selectedCountry}
                    onChange={onCountryChange}
                    options={countries}
                    clearable={false}
                    className="react-select"
                    placeholder={'Select Country'}
                    classNamePrefix="react-select"
                />
            </div>
            <div className="col-md-3 px-0 pr-3" >
                <Select
                    value={selectedVendor}
                    onChange={onVendorChange}
                    options={vendors}
                    clearable={false}
                    className="react-select"
                    placeholder={'Select Vendor'}
                    classNamePrefix="react-select"
                />
            </div>
            <div className="col-md-4  pl-0">
                <p className="">&nbsp;</p>
                <div className='flex'>

                    <Button
                        type='submit'
                        className="btn btn-sm btn-primary"
                        color="#ffffff"
                    
                    >   
                        Filter
                    </Button>
                    <Button
                        onClick={(e)=>onClickFilter(e,true)}
                        className="btn btn-sm btn-secondary"
                        color="#ffffff"
                    >
                        Reset
                    </Button>
                </div>
                
            </div>
        </form>
    )
}

export default MerchantFilter;